// src/store/store.js
import { configureStore } from '@reduxjs/toolkit'
import { socketService } from '../services/socket.service'

/* --- reducers ישנים --- */
import { userReducer, updateUser } from './slices/user.slice'
import {
  postReducer,
  addPostDirect,
  updatePostDirect,
  removePostDirect,
} from './slices/post.slice'
import {
  commentReducer,
  addCommentDirect,
  updateCommentDirect,
  removeCommentDirect,
} from './slices/comment.slice'
import {
  reviewReducer,
  addReviewDirect,
  updateReviewDirect,
  removeReviewDirect,
} from './slices/review.slice'
import { animeFeaturesReducer } from './slices/animeFeatures.slice'
import { uiReducer } from './slices/ui.slice'

/* --- reducer החדש של watchlist --- */
import {
  watchlistReducer,
  addItem, // thunk
  updateItem,
  removeItem,
} from './slices/watchlist.slice'
import { fetchAnimesByIds, animeDBReducer } from './slices/animeDB.slice'

/* ---------------------------------------------------------- */
export const store = configureStore({
  reducer: {
    userModule: userReducer,
    postModule: postReducer,
    commentModule: commentReducer,
    watchlist: watchlistReducer, // ← Redux Toolkit slice
    animeDB: animeDBReducer,
    reviewModule: reviewReducer,
    animeFeatures: animeFeaturesReducer,
    ui: uiReducer,
  },
})
/* ---------------------------------------------------------- */
/* -------- Socket wiring (posts / comments / reviews) ------- */
socketService.on('post-added', (p) => store.dispatch(addPostDirect(p)))
socketService.on('post-updated', (p) => store.dispatch(updatePostDirect(p)))
socketService.on('post-removed', (id) => store.dispatch(removePostDirect(id)))

socketService.on('comment-added', (c) => store.dispatch(addCommentDirect(c)))
socketService.on('comment-updated', (c) =>
  store.dispatch(updateCommentDirect(c))
)
socketService.on('comment-removed', (id) =>
  store.dispatch(removeCommentDirect(id))
)

socketService.on('user-updated', (u) => store.dispatch(updateUser(u)))

socketService.on('review-added', (r) => store.dispatch(addReviewDirect(r)))
socketService.on('review-updated', (r) => store.dispatch(updateReviewDirect(r)))
socketService.on('review-removed', (id) =>
  store.dispatch(removeReviewDirect(id))
)
/* ---------------- watchlist socket events ------------------ */
/*  השולח בצד ה-Backend מעביר: {listType, item, userId}        */

socketService.on('item-added', ({ listType, item, userId }) => {
  // ➊ עדכון הסלייס
  store.dispatch(
    addItem.fulfilled({
      userId,
      listType,
      item, // ← שים לב: עוטפים אותו ב־payload.item
    })
  )

  // ➋ הבאת המטא־דטה מיד אחרי
  if (item?.anizone_id) {
    store.dispatch(fetchAnimesByIds([item.anizone_id]))
  }
})

socketService.on('item-updated', ({ listType, item, userId }) => {
  store.dispatch(updateItem.fulfilled({ ...item, listType, userId }))
})

socketService.on('item-removed', ({ listType, anizoneId, userId }) => {
  store.dispatch(removeItem.fulfilled({ listType, anizoneId, userId }))
})

/* ----------------- misc anime feature events --------------- */
socketService.on('anime-schedules-updated', (d) =>
  store.dispatch({ type: 'UPDATE_ANIME_SCHEDULES', payload: d })
)

socketService.on('classic-animes-updated', (d) =>
  store.dispatch({ type: 'UPDATE_CLASSIC_ANIMES', payload: d })
)

socketService.on('popular-animes-updated', (d) =>
  store.dispatch({ type: 'UPDATE_POPULAR_ANIMES', payload: d })
)
